/**
 Class representing a matrix row answer.
 */
export class MatrixAnswer {
    /**
     * Create a matrix (row) answer.
     * @param {Object} matrixAnswer - The matrix answer
     * @param {Number} matrixAnswer.matrixRowId - The id of the row for the matrix question.
     * @param {Array<Number>} matrixAnswer.alternativeIds - The selected alternativeIds.
     */
    constructor(matrixAnswer) {
        this.matrixRowId = matrixAnswer.matrixRowId;
        this.alternativeIds = matrixAnswer.alternativeIds ? matrixAnswer.alternativeIds : [];
    }
}
